import moment from 'moment'

export const isEmpty = value => {
  if (value === null || value === undefined || value === '') {
    return true
  }
}

export const toDateSting = value => {
  if (isEmpty(value)) return ''

return moment(value).format('YYYY-MM-DD')
}

export const hasErrorsForProperty = (errors, property) => errors[property] !== undefined

export const errorMessages = (errors, property) => (errors[property] === undefined ? null : errors[property][0])

export const hasPermission = value => {
  if (isEmpty(value)) return true
  const data = JSON.parse(localStorage.getItem('userData'))
  if (data === undefined || data === null) {
    return true
  }

return data.permissions.includes(value)
}

export const toLocalDate = value => {
  if (isEmpty(value)) return ''

return new Date(value).toISOString().substr(0, 10)
}

export const toDateTimeString = value => {
  if (isEmpty(value)) return ''

return moment(value).format('YYYY-MM-DD HH:mm:ss')
}

export const toBackDateTimeString = value => {
  if (isEmpty(value)) return ''

return moment(value).format('YYYY-MM-DDTHH:mm:ss')
}

export const toTimeString = value => {
  if (isEmpty(value)) return ''

return moment(value).format('HH:mm:ss')
}

export const isEmptyOrSpaces = str => str === undefined || str === null || str.trim() === ''

export const MONTHS_OF = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
]

export const plural = (count, [one, few, many]) => {
  if (!Number.isInteger(count)) return few

  const tail = Math.abs(count) % 100
  const last = tail % 10

  if (tail > 10 && tail < 20) return many
  if (last === 1) return one

  return last >= 2 && last <= 4 ? few : many
}

export const money = value => (value === null || value === undefined
  ? '—'
  : `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(value)} сом`)
